import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "form-group form-check" }
const _hoisted_2 = ["id", "checked"]
const _hoisted_3 = ["for"]
const _hoisted_4 = ["title"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("sup", null, "*", -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 0,
  class: "mt-1 mb-4"
}
const _hoisted_8 = ["href", "title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_control_error_message = _resolveComponent("control-error-message")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("input", {
      type: "checkbox",
      id: _ctx.compId,
      checked: _ctx.modelValue,
      onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onChange($event.target.checked))),
      class: _normalizeClass([{ 'form-error-focusable': _ctx.validation.$error }, "form-check-input"])
    }, null, 42, _hoisted_2),
    _createElementVNode("label", { for: _ctx.compId }, [
      _createTextVNode(_toDisplayString(_ctx.$t(_ctx.i18nLabel)) + " ", 1),
      (_ctx.isRequired())
        ? (_openBlock(), _createElementBlock("abbr", {
            key: 0,
            title: _ctx.$t('common.form.required')
          }, _hoisted_6, 8, _hoisted_4))
        : _createCommentVNode("", true)
    ], 8, _hoisted_3),
    (_ctx.forCaptcha)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("a", {
            href: _ctx.sanitizeUrl(_ctx.$t('views.yourPersonalData.infoTextLink')),
            title: _ctx.$t('views.yourPersonalData.infoTextLinkTitle'),
            target: "_blank",
            rel: "noopener noreferrer"
          }, _toDisplayString(_ctx.$t('views.yourPersonalData.infoTextLinkTitle')), 9, _hoisted_8)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_control_error_message, {
      validation: _ctx.validation,
      i18nLabel: _ctx.i18nLabel
    }, null, 8, ["validation", "i18nLabel"])
  ]))
}